@if (is_initial_step()) {

    <div class="choice-selection">
        <button class="choice-button" (click)="createNewRoom()">
            <div class="choice-info">
            <span class="choice-name">Create new room</span>
            <span class="choice-desc">Start a fresh game session</span>
            </div>
        </button>
        
        <button class="choice-button" (click)="showJoinInput()">
            <div class="choice-info">
            <span class="choice-name">Join existing room</span>
            <span class="choice-desc">Enter a code to join your friends</span>
            </div>
        </button>
    </div>

}

@else if (is_join_step()) {

    <div class="join-section">

        <div class="input-wrapper">
            <input 
                class="join-input"
                [class.error]="!is_manual_room_id_valid()"
                type="text" 
                [value]="manual_room_id()" 
                (input)="updateManualRoomId($event)" 
                placeholder="Enter room code" 
                spellcheck="false"
                autocomplete="off"
            />
            @if (!is_manual_room_id_valid()) {
                <span class="join-error">Invalid room code. Please check for typos.</span>
            }
        </div>

        <button
            class="join-submit"
            (click)="submitManualRoomId()"
            [disabled]="is_joining() || !is_manual_room_id_valid() || !manual_room_id().trim()"
        >
            @if (is_joining()){ <div class="loader"></div> }
            @else { Join Room }
        </button>
        <button class="join-back" (click)="showInitialStep()">Back</button>

    </div>

}

@else {

    <div class="room-card">

        <div class="room-header">
            <span class="room-label">ROOM CODE</span>
            <div class="room-value">
            @if (room_id()) {
                <span class="room-code">{{room_id() | uppercase}}</span>
            }
            @else {
                <div class="loader"></div>
            }
            </div>
        </div>
        
        <div class="room-actions">

            <button
                class="icon-button"
                (click)="copyRoomUrl()"
                [title]="is_room_url_copied() ? 'Copied' : 'Copy Link'"
                [disabled]="!room_id()"
            >
                <img [src]="is_room_url_copied() ? 'assets/content_copied.svg' : 'assets/content_copy.svg'" alt="copy" />
            </button>
            
            <button
                class="icon-button"
                (click)="shareRoomUrl()"
                title="Share Link"
                [disabled]="!room_id()"
            >
                <img src="assets/share.svg" alt="share" />
            </button>

            <button
                class="icon-button"
                (click)="refreshRoom()"
                title="New Room"
                [disabled]="!room_id()"
            >
                <img src="assets/refresh.svg" alt="refresh" />
            </button>

        </div>

    </div>
    
}
